export class PackageModel {

  public p02_key: string = undefined;
  public p02_abmp_mbt_key: string = undefined;
  public p02_ascp_mbt_key: string = undefined;
  public p02_ahp_mbt_key: string = undefined;
  public p02_anp_mbt_key: string = undefined;
  public p02_combo_description: string = undefined;
  public p02_combo_price: number = undefined;
  public p02_combo_detail_description: string = undefined;
  public p02_terms_and_conditions: string = undefined;
  public p02_sort_order: number = undefined;

  public ABMP = false;
  public ASCP = false;
  public AHP = false;
  public ANP = false;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
